import React, { useEffect, useState } from 'react';
import { thumbnailRenderingConfig, defaultRenderingConfig } from '../config/renderingConfig.js';
import { generateCachedLampThumbnail } from '../utils/thumbnailGenerator.js';

const LampThumbnail = ({ design, thumbnail, alt }) => {
  const [generatedThumbnail, setGeneratedThumbnail] = useState(thumbnail || null);

  useEffect(() => {
    if (thumbnail) {
      return; // Use provided thumbnail
    }
    
    if (!design) {
      return;
    }
    
    // Generate a stable ID if one doesn't exist (for cart items)
    const designId = design.id || `temp-${JSON.stringify(design.baseShape || {}).slice(0, 50)}`;
    
    if (!designId) {
      return;
    }
    
    const cacheKey = `lamp_thumbnail_${designId}`;
    let cached = localStorage.getItem(cacheKey);
    if (cached) {
      setGeneratedThumbnail(cached);
      return;
    }

    // Generate thumbnail using utility
    (async () => {
      try {
        // Ensure design has an ID for caching
        const designWithId = { ...design, id: designId };
        
        const preview = await generateCachedLampThumbnail(designWithId, {
          maxDimension: 1024,
          includeWireframe: true
        });
        
        if (preview && preview.startsWith('data:image')) {
          setGeneratedThumbnail(preview);
        }
        
      } catch (error) {
        console.error('Thumbnail generation failed:', error);
      }
    })();
  }, [thumbnail, design]);
  
  return (
    <div className="design-thumbnail" style={{ 
      width: '100%', 
      height: '100%',
      minHeight: '80px',
      margin: '0 auto', 
      borderRadius: '8px', 
      overflow: 'hidden', 
      background: thumbnailRenderingConfig.background?.color || defaultRenderingConfig.background.color,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    }}>
      {generatedThumbnail ? (
        <img 
          src={generatedThumbnail} 
          alt={alt} 
          style={{ 
            maxWidth: '100%', 
            maxHeight: '100%', 
            width: 'auto',
            height: 'auto',
            display: 'block',
            objectFit: 'contain'
          }}
          onError={(e) => {
            console.error('Thumbnail image failed to load:', e);
          }}
        />
      ) : (
        <div style={{ 
          width: '100%', 
          height: '100%', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          color: '#aaa',
          background: thumbnailRenderingConfig.background?.color || defaultRenderingConfig.background.color 
        }}>Generating...</div>
      )}
    </div>
  );
};

export default LampThumbnail; 
